import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Admin',
	url: '/admins',
	icon: 'dashboard',
}];

export default class Admin extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.customer = null;
		this.state.location = null;
		this.state.customers = null;
		this.state.locations = null;
		this.state.saveCustomer = false;
		this.state.saveLocation = false;
		this.state.saveTicket = false;
	}

	reloadPage = () => {
		this.setState({
			customer: null,
			location: null,
			customers: null,
			locations: null,
			refresh: !this.state.refresh
		})
	};

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>

				<div className={"row"}>
					<div className={"col-5"}>
					  <Collections.AdminsCustomers
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							loadCustomer={(customer, location) => {
								this.setState({
									customer: customer,
									location: location,
								})
							}}
							showCSV={roles.includes(UserRoles.Admin)}
						/>
					</div>
					<div className={"col-7"}>
					  <Collections.AdminsTickets
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							loadCustomer={(customer, location) => {
								this.setState({
									customer: customer,
									location: location,
								})
							}}
							showCSV={roles.includes(UserRoles.Admin)}
					  />
					</div>
				</div>
			</div>
		);
	}
}


